import type { RootState } from '@/store/store';

const selectListFeedbacks = (state: RootState) => state.listFeedbacks;

export const selectFeedbacks = (state: RootState) => selectListFeedbacks(state).feedbacks;
export const selectLoadStatus = (state: RootState) => selectListFeedbacks(state).loadStatus;
export const selectOpenCount = (state: RootState) => selectListFeedbacks(state).openCount;
export const selectStatusUpdate = (state: RootState) => selectListFeedbacks(state).statusUpdate;

/** The feedback a `?feedback=` address names, once the table holds it. */
export const selectFeedbackById = (state: RootState, id: string | null) =>
  id ? (selectFeedbacks(state).find((f) => f.id === id) ?? null) : null;
